<template>
  <div>
    <div class="pa-3" style="display: flex">
      <h1>Dine-In Store Type Management</h1>
      <!-- <v-spacer></v-spacer>
      <v-btn color="primary" style="color: black"
        ><v-icon>add</v-icon> create</v-btn
      > -->
    </div>
    <v-data-table
      style="border: 1px solid black"
      :headers="headers"
      :search="search"
      :loading="is_loading_store"
      :items="store_type"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td style="display: flex; justify-content: center; margin-top: 25px">
          <div>
            <v-switch
              v-model="props.item.store_type_status"
              color="primary"
              @change="changeState(props.item)"
            ></v-switch>
          </div>
        </td>
        <td class="text-xs-center">
          {{ props.item.store_type_name_th }}
        </td>
        <td class="text-xs-center">
          {{ props.item.store_type_name_en }}
        </td>
        <td class="text-xs-center">
          <button
            class="view-detail-btn"
            @click="openEditDineInStoreType(props.item)"
          >
            <v-icon style="font-size: 18px; color: white">edit</v-icon>
          </button>
          <button
            class="delete-btn"
            @click="openDeleteStoreType(props.item.store_type_id)"
          >
            <v-icon style="font-size: 18px; color: white">delete</v-icon>
          </button>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="dinein_store_list.length == 0 && is_loading_store != true">
          No data available
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ is_loading_store == true ? "Loading data ..." : is_loading_store }}
        </div>
      </template>
    </v-data-table>

    <v-dialog
      v-model="edit_store_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <div style="color: black">
              {{ edit_item.store_type_name_en }}
            </div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="edit_store_dialog = false">
              <v-icon color="black">close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <EditStoreType
          :store_type_data="edit_item"
          @closeEditDialog="watchEditDialog"
        ></EditStoreType>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline yellow lighten-2" primary-title>
          Delete Store
        </v-card-title>

        <v-card-text style="font-size: 1.35rem; margin-block: 15px">
          Are you sure to permanent delete this store?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="deleteDialog = false"> Cancel </v-btn>
          <v-btn color="primary" flat @click="deleteStoreType"> Confirm </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="error_dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline yellow lighten-2" primary-title>
          Delete Failed
        </v-card-title>

        <v-card-text style="font-size: 1.35rem; margin-block: 15px">
          Your deletion failed with some problems. Please try again.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_dialog = false"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="error_type_dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline yellow lighten-2" primary-title>
          Delete Failed
        </v-card-title>

        <v-card-text style="font-size: 1.35rem; margin-block: 15px">
          Your deletion failed because this type still have stores that were in
          this type. Please check store again.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_type_dialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import EditStoreType from "../../../../components/back-office/DineIn/Store/EditStoreType.vue";
export default {
  data: () => ({
    search: "",
    detail_dialog: false,
    dialog: false,
    change: 0,
    edit_store_dialog: false,
    is_loading_store: false,
    error_type_dialog: false,
    deleteDialog: false,
    edit_item: 0,
    store_type: [],
    delete_id: "",
    error_dialog: false,
    store_name_th: null,
    pagination: {
      page_size: 100,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "store_status",
        sortable: false,
      },
      {
        text: "Store Type Name TH",
        align: "center",
        value: "store_type_name_th",
        sortable: false,
      },
      {
        text: "Store Type Name EN",
        align: "center",
        value: "store_type_name_en",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "",
        sortable: false,
      },
    ],
  }),
  components: { EditStoreType },
  computed: {
    ...mapState({
      dinein_store_list: (state) => state.fetchDineIn.store_list,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    ...mapGetters(["isEditStoreApprove"]),
    pages() {
      if (this.dinein_store_list.length != 0) {
        this.pagination.totalItems = this.dinein_store_list.length;
      }
      if (
        this.pagination.page_size == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.page_size);
    },
  },
  watch: {
    change: function() {
      this.fetchData();
    },
  },

  created() {
    this.fetchData();
  },
  methods: {
    moment,
    openEditDineInStoreType(index) {
      this.edit_item = index;
      this.edit_store_dialog = true;
      this.change++;
    },
    openDeleteStoreType(storeid) {
      this.delete_id = storeid;
      this.deleteDialog = true;
      this.change++;
    },
    watchEditDialog() {
      this.edit_store_dialog = false;
      this.change++;
    },
    watchEditTimeDialog() {
      this.edit_store_time_dialog = false;
      this.change++;
    },
    async deleteStoreType(id) {
      var res = await this.$store.dispatch(
        "fetchDineIn/deleteDineInStoreType",
        this.delete_id
      );
      if (res.msg === true) {
        if (res.data === "can not delete") {
          this.deleteDialog = false;
          this.error_type_dialog = true;
          return;
        } else {
          this.deleteDialog = false;
          const stores = this.store_type.filter(
            (obj) => obj.store_type_id !== this.delete_id
          );
          this.store_type = stores;
        }
      } else {
        this.deleteDialog = false;
        this.error_dialog = true;
      }
    },
    async changeState(item) {
      var payload = {
        data: {
          store_type_id: item.store_type_id,
          store_type_name_th: item.store_type_name_th,
          store_type_name_en: item.store_type_name_en,
          store_type_status: item.store_type_status,
          store_type_profile: item.store_type_image,
        },
      };
      var res = await this.$store.dispatch(
        "fetchDineIn/updateDineInStoreType",
        payload
      );
      if(res == false) item.store_type_status = !store_type_status
    },
    getProvinceName(id) {
      let isFound = "";
      for (let i = 0; i < this.provinceData.length; i++) {
        if (this.provinceData[i].province_id == id) {
          isFound = this.provinceData[i].province_name_en;
        }
      }
      if (isFound != "") {
        return isFound;
      } else {
        return null;
      }
    },
    async fetchData() {
      this.is_loading_store = true;
      this.store_type = await this.$store.dispatch(
        "fetchDineIn/getDineInStoreType"
      );
      this.is_loading_store = false;
    },
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}

.view-detail-btn {
  font-size: 13px;
  outline: none;
  background-color: #2196f3;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.edit-time-btn {
  font-size: 13px;
  outline: none;
  background-color: #2175f3;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.delete-btn {
  font-size: 13px;
  outline: none;
  background-color: red;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>
